<template>
  <div>
    <div class="row my-2">
      <div class="col-6">
        <span class="data-title d-block mb-2">
          Reportes:
        </span>
        <validation-provider v-slot="{ errors }" name="portal" rules="required">
          <custom-drop-down
            id="reports"
            fieldkey="id"
            fieldname="name"
            v-model="model.reportType"
            placeholder="Seleccione"
            custom-error-msg="El campo es requerido."
            :error="errors[0]"
            :options="reportTypes"
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
      <div class="col-6">
        <span class="data-title d-block mb-2">
          Tipo de Gráfica:
        </span>
        <validation-provider v-slot="{ errors }" name="portal" rules="required">
          <custom-drop-down
            v-model="model.graphicType"
            id="graphicType"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            custom-error-msg="El campo es requerido."
            :error="errors[0]"
            :options="graphicTypes"
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from 'icon-view';
import CustomDropDown from 'custom-drop-down';
import Error from '@/components/common/Error';

import {
  getReportTypes,
  getGraphicTypes,
} from '@/services/operations/dashboard-management';

export default {
  name: 'Graphic',
  components: {
    IconView,
    CustomDropDown,
    Error,
  },
  data() {
    return {
      graphicTypes: [],
      reportTypes: [],
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    type: {
      type: Number,
      default: () => 0,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      await this.getGraphicTypes();
      await this.getReportTypes();
    },
    async getReportTypes() {
      const { data } = await getReportTypes();
      this.reportTypes = data;
    },
    async getGraphicTypes() {
      const { data } = await getGraphicTypes();
      this.graphicTypes = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.textarea__extended ::v-deep {
  .position-relative {
    i {
      display: none;
    }
  }
}

.div-time {
  margin-top: 12px !important;
}
</style>
